import cn from 'classnames';

type Props = {
  items: string[];
  font?: string;
  className?: string;
};

export default function SliderTextItem(props: Props) {
  return (
    <article
      className={cn(
        'flex flex-col items-center justify-start space-y-2',
        props.className
      )}
    >
      {props.items.map((item, idx) => (
        <p
          key={idx}
          className={cn('text-body16 truncate text-black', props.font)}
        >
          {item}
        </p>
      ))}
    </article>
  );
}
